/* eslint-disable new-cap */
/* eslint-disable no-new */
import { useEffect, useRef } from 'react';
import { Adriver } from '../../types';
import useScreenSize from '../useScreenSize';

const bannerData = { sid: 220686, bt: 52, bn: 8, w: 800, h: 600 };

interface useGalleryBannerProps {
  bannerId?: string;
  isBannerActivated?: boolean;
  isNextBanner?: boolean;
  setShouldRenderBanner?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useGalleryBanner = ({
  bannerId,
  isBannerActivated,
  isNextBanner,
  setShouldRenderBanner
}: useGalleryBannerProps) => {
  const banner = useRef<null | Adriver>(null);
  const { isLarge } = useScreenSize();

  useEffect(() => {
    if (!isBannerActivated || !bannerId || !isLarge) return;

    try {
      banner.current = new window.adriver(bannerId, bannerData);
    } catch (e) {
      console.error(e);
    }
  }, [isBannerActivated, bannerId, isLarge]);

  useEffect(() => {
    if (!isBannerActivated || !bannerId || !isLarge) return;
    const bannerElement = document.getElementById(bannerId);
    if (
      banner.current &&
      banner.current?.loadCompleteQueue?.flag &&
      bannerElement
    ) {
      bannerElement.innerHTML = '';

      banner.current?.reload();
    }
  }, [isBannerActivated, bannerId, isLarge]);

  useEffect(() => {
    if (!isBannerActivated || !bannerId || !isLarge) return;
    const bannerElement = document.getElementById(bannerId);
    if (bannerElement) {
      bannerElement.innerHTML = '';
    }

    if (typeof window !== 'undefined' && typeof window.adriver === 'function') {
      window.adriver(bannerId, {
        ...bannerData
      });
    }
  }, [isBannerActivated, bannerId, isLarge]);

  useEffect(() => {
    const innerHtml = banner.current?.p?.innerHTML;

    if (!innerHtml && isNextBanner && setShouldRenderBanner) {
      setShouldRenderBanner(false);
    }
  }, [banner.current?.p?.innerHTML, isNextBanner]);
};
